export type PreviewPage = {
  src: string;
  alt: string;
};

export const previewPages: PreviewPage[] = [
  {
    src: 'https://cdn.magicpatterns.com/uploads/3WaxoPDxuqhBegYkFcx3fe/PAGINA_3.png',
    alt: "Sample page Light in Glass Carries the World's Traffic, explaining why telecom networks are built on fiber",
  },
  {
    src: 'https://cdn.magicpatterns.com/uploads/8QjoiD4BD1kssCN92oxRZ5/PAGINA_8.png',
    alt: 'Sample page A Fiber Is Thinner Than a Human Hair and Built in Three Layers, showing the anatomy of an optical fiber',
  },
  {
    src: 'https://cdn.magicpatterns.com/uploads/h5enW5FxFYBp42QN3nowA8/PAGINA_21.png',
    alt: 'Sample page Twelve Colours Identify Every Fiber, showing fiber and buffer-tube colour codes',
  },
  {
    src: 'https://cdn.magicpatterns.com/uploads/8L7fAqesBgej42JC5uWGT1/PAGINA_31.png',
    alt: 'Sample page Green Means Angled; Never Mate It With Blue, comparing PC, UPC and APC connector polish',
  },
  {
    src: 'https://cdn.magicpatterns.com/uploads/9H7ErwTbW57TkrEP9NG7XF/PAGINA_40.png',
    alt: 'Sample page Every Bump on the Trace Is a Story, explaining how to read an OTDR trace',
  },
];
